import { PageMode } from '@/main/utils/pageMode';

import Edit from './Edit.vue';
import { NAME, DMS_MODULE, CRUMB_LABEL_KEY } from './constants';

export const router = {
	path: `/${DMS_MODULE}/${NAME}/${PageMode.EDIT}/1`,
	component: Edit,
	meta: { objectName: CRUMB_LABEL_KEY },
	name: NAME,
	props: true,
};
